import React from 'react';
export const Skills = (props) => {
	return (
		<section
			id='skills-section'
			className='skills section'
        >
			<h2 className='skills-header section-header'>
				Skills
			</h2>
			<div className='skills-container'>
				<ul>
                    <li>JavaScript</li>
                    <li>Vue</li>
					<li>React</li>
                    <li>Node.js</li>
					<li>WordPress</li>
					<li>PHP</li>
					<li>Laravel</li>
                    <li>SCSS</li>
                    <li>Tailwind</li>
                    <li>And more!</li>
				</ul>
			</div>
		</section>
	);
};
